import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { useOktaAuth } from "@okta/okta-react";
import { postData } from "@/lib/utils";
import pino from "pino";
import OktaWidgetLoginContainer from "@/components/okta/OktaWidgetContainer";
const log = pino().child({ name: "open/login" });
export default () => {
    const { oktaAuth, authState } = useOktaAuth();
    const router = useRouter();
    const [ranHandle, setRanHandle] = useState(false);
    // Temporarily handle whether we show the okta widget or regular login button here
    // runs once on page load
    // We can end up on /open/login with Okta logged in but our cookie unset.
    // Handle that in this effect
    useEffect(() => {
        log.info({ authState, router, ranHandle }, "Running effect");
        if (authState === null || router === undefined || ranHandle) {
            return;
        }
        if (!authState.isAuthenticated) {
            log.info("Skipping unauthenticated");
            return;
        }
        const handle = async () => {
            if (authState.accessToken?.accessToken === undefined) {
                log.info("Authenticated but no tokens? Trying signOut...");
                log.info({ signOut: await oktaAuth.signOut() }, "Reloading page after signOut");
                router.reload();
                return;
            }
            log.info("Setting token");
            await postData("/api/open/token", {
                accessToken: authState.accessToken.accessToken,
            });
            log.info("Pushing");
            void router.push("/");
        };
        log.info("Running handle");
        setRanHandle(true);
        handle().catch((error) => {
            // TODO: Do something better
            console.error(error);
        });
    }, [authState, oktaAuth, ranHandle, router]);
    return <OktaWidgetLoginContainer />;
};
